import { useMemo } from "react"
//give back the first gtt team in a shoot
const useFirstGTTMember = usersRolesArray => {
  return useMemo(
    () => {
      let goToTeamArray = usersRolesArray.filter(
        x => x.user_company === "Go To Team"
      )
      return goToTeamArray.length > 0 ? goToTeamArray[0].user_id : undefined
    },
    [usersRolesArray]
  )
}

export default useFirstGTTMember
